import React from "react";
import { Outlet } from "react-router-dom";
import AppWrapper from "./components/appWrapper";
import Background from "./components/background";
import NavBar from "./components/navBar";
import Drawer from "./components/drawer/drawer";
import AtheismLogo from "./components/atheismLogo";
import FocusTrap from "./components/readingFocusTrap/readingFocusTrap";
import TitleText from "./components/titleText";

const App = () => {
  return (
    <AppWrapper>
      <Background />
      <NavBar />
      <Drawer />
      <AtheismLogo />
      <Outlet />
      <TitleText />
      <FocusTrap />
    </AppWrapper>
  );
};

export default App;
